/**
 * Consolidates paths and routing into one place
 * @See AppV2.jsx
 * @See {Route} from react-router-dom
 */
import { isPaxSelector } from 'selectors/app-selector';
import _get from 'lodash/get';
import { getCompany } from 'helper/user';
import _isEmpty from 'lodash/isEmpty';
import _isUndefined from 'lodash/isUndefined';
import LoginView from 'views/login-view';
import NotFoundView from 'views/not-found-view';
import LKKPVerifyView from 'views/verify-lkpp-view';
import Home from 'views/v2/home';
import GfbRedirect from 'views/v2/gfb-redirect';
import GrabIDRedirect from 'views/v2/grab-id-redirect';
import { ROUTES_V2_PATHS, ROUTES_V2_KEYS } from 'constants/route-constants';
import { AuthComponentHOC } from 'helper/auth-component-v2';
import { ShopifyLandingPage } from 'views/v2/shopify-landing';
import { ShopifyHome } from 'views/v2/shopify-home';
import Waybills from 'views/v2/waybills/waybills';
import ShopifySettings from 'views/v2/shopify-home/shopify-settings';
import ShopifyLink from 'views/v2/shopify-home/shopify-link';
import NewBookingPage from 'views/v2/new-booking-page';
import BulkUploadPage from 'views/v2/new-bulk-upload';
import OVOCallback from 'components/v2/ovo/ovo-callback';
import BookingTablePageSwitch from 'views/v2/new-booking-table-page/booking-table-page-switch';
import GfbLoginSuccessRedirect from 'views/v2//gfb-login-success-redirect';

const RoutesV2 = {
  login: {
    key: ROUTES_V2_KEYS.login,
    path: ROUTES_V2_PATHS.login,
    component: LoginView,
  },
  loginSuccessRedirect: {
    key: ROUTES_V2_KEYS.gfbLoginSuccessRedirect,
    path: ROUTES_V2_PATHS.gfbLoginSuccessRedirect,
    component: GfbLoginSuccessRedirect,
  },
  signup: {
    key: ROUTES_V2_KEYS.signUp,
    path: ROUTES_V2_PATHS.signUp,
  },
  home: {
    key: ROUTES_V2_KEYS.home,
    path: ROUTES_V2_PATHS.home,
    component: AuthComponentHOC(Home, true, state => {
      const cities = _get(state, 'app.cities');
      const payments = _get(state, 'booking.paymentMethods');
      const serviceTypeMap = _get(state, 'booking.serviceTypeMap');
      return (
        !_isEmpty(cities) &&
        !_isUndefined(payments) &&
        !_isEmpty(serviceTypeMap)
      );
    }),
  },
  newBooking: {
    key: ROUTES_V2_KEYS.newBooking,
    path: ROUTES_V2_PATHS.newBooking,
    component: NewBookingPage,
  },
  bulkUpload: {
    key: ROUTES_V2_KEYS.bulkUpload,
    path: ROUTES_V2_PATHS.bulkUpload,
    component: BulkUploadPage,
  },
  ovoCallback: {
    key: ROUTES_V2_KEYS.ovoCallback,
    path: ROUTES_V2_PATHS.ovoCallback,
    component: OVOCallback,
  },
  bookings: {
    key: ROUTES_V2_KEYS.bookings,
    path: ROUTES_V2_PATHS.bookings,
    component: AuthComponentHOC(BookingTablePageSwitch, true, state => {
      if (isPaxSelector(state)) return true;
      const company = getCompany(state.app.userInfo);
      return !_isEmpty(company);
    }),
  },
  waybills: {
    key: ROUTES_V2_KEYS.waybills,
    path: ROUTES_V2_PATHS.waybills,
    component: AuthComponentHOC(Waybills),
  },
  redirectGfb: {
    key: ROUTES_V2_KEYS.redirectGfb,
    path: ROUTES_V2_PATHS.redirectGfb,
    component: AuthComponentHOC(GfbRedirect),
  },
  errors: {
    key: ROUTES_V2_KEYS.errors,
    path: ROUTES_V2_PATHS.errors,
    component: AuthComponentHOC(NotFoundView),
  },
  verifyLKKP: {
    key: ROUTES_V2_KEYS.verifyLKKP,
    path: ROUTES_V2_PATHS.verifyLKKP,
    component: LKKPVerifyView,
  },
  redirectGrabId: {
    key: ROUTES_V2_KEYS.redirectGrabId,
    path: ROUTES_V2_PATHS.redirectGrabId,
    component: GrabIDRedirect,
  },
  shopifyLanding: {
    key: ROUTES_V2_KEYS.shopifyLanding,
    path: ROUTES_V2_PATHS.shopifyLanding,
    component: ShopifyLandingPage,
  },
  shopifyHome: {
    key: ROUTES_V2_KEYS.shopifyHome,
    path: ROUTES_V2_PATHS.shopifyHome,
    component: ShopifyHome,
  },
  shopifySettings: {
    key: ROUTES_V2_KEYS.shopifySettings,
    path: ROUTES_V2_PATHS.shopifySettings,
    component: ShopifySettings,
  },
  shopifyLink: {
    key: ROUTES_V2_KEYS.shopifyLink,
    path: ROUTES_V2_PATHS.shopifyLink,
    component: ShopifyLink,
  },
};

export const ValidPaths = Object.values(RoutesV2).map(route => route.path);

export default RoutesV2;
